/**
 * SearchApi — czysty serwis sieciowy wyszukiwania RAG.
 * Jedyna odpowiedzialność: fetch do /api/screen1/search-rag.
 * Nie wie nic o animacjach, krokach, DOM ani stanie UI.
 */

import { decryptFromStore } from '../utils/secureStorage';

const LS_KEY_JWT = 'pwa_jwt';

async function getAuthToken(): Promise<string | null> {
  return await decryptFromStore(LS_KEY_JWT);
}

export interface RawSearchMeta {
  totalFound: number;
  searchTimeMs: number;
  parsedDateStart?: string | null;
  parsedDateEnd?: string | null;
  searchConcept?: string | null;
  fallback?: boolean;
  error?: string;
}

export interface RawSearchItem {
  conversation_id?: number;
  conversationId?: number;
  employee_id?: number | null;
  employeeId?: number | null;
  first_name?: string;
  firstName?: string;
  last_name?: string;
  lastName?: string;
  position?: string;
  short_summary?: string;
  shortSummary?: string;
  long_summary?: string;
  longSummary?: string;
  arrangements_json?: any;
  created_at?: string;
  createdAt?: string;
  _meta?: { similarityScore?: number };
}

export interface RawSearchResponse {
  items: RawSearchItem[];
  ragAnswer: string | null;
  searchMeta: RawSearchMeta;
  warning?: string;
}

export interface SearchApiOptions {
  within?: number[];
  synthesize?: boolean;
}

/**
 * Wykonuje zapytanie RAG do backendu.
 * Timeout: 10 sekund (AbortSignal.timeout).
 * Rzuca Error przy błędzie HTTP lub przekroczeniu timeoutu.
 */
export async function fetchSearch(
  query: string,
  options?: SearchApiOptions
): Promise<RawSearchResponse> {
  const params = new URLSearchParams({ q: query });
  if (options?.within && options.within.length > 0) {
    params.set('within', options.within.join(','));
  }
  params.set('synthesize', options?.synthesize === false ? 'false' : 'true');

  const url = `/api/screen1/search-rag?${params.toString()}`;

  const token = await getAuthToken();
  const headers: Record<string, string> = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const response = await fetch(url, {
    method: 'GET',
    headers,
    signal: AbortSignal.timeout(30_000),
  });

  if (!response.ok) {
    throw new Error(`SearchApi: HTTP ${response.status} ${response.statusText}`);
  }

  return response.json() as Promise<RawSearchResponse>;
}
